import React, { useState, useEffect, useCallback } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import api from '../utils/api';

const Icon = ({ name, size = 16, color = 'currentColor' }) => {
  const icons = {
    users:    <><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></>,
    bell:     <><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></>,
    download: <><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></>,
    slash:    <><circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/></>,
    key:      <><path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"/></>,
    refresh:  <><path d="M1 4s0-3 3-3c3 0 5 2 5 2"/><path d="M1 4v4h4"/><path d="M15 12s0 3-3 3c-3 0-5-2-5-2"/><path d="M15 12v-4h-4"/></>,
    clock:    <><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></>,
    mail:     <><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></>,
    lock:     <><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></>,
    cpu:      <><rect x="4" y="4" width="16" height="16" rx="2"/><rect x="9" y="9" width="6" height="6"/><line x1="9" y1="1" x2="9" y2="4"/><line x1="15" y1="1" x2="15" y2="4"/><line x1="9" y1="20" x2="9" y2="23"/><line x1="15" y1="20" x2="15" y2="23"/><line x1="20" y1="9" x2="23" y2="9"/><line x1="20" y1="14" x2="23" y2="14"/><line x1="1" y1="9" x2="4" y2="9"/><line x1="1" y1="14" x2="4" y2="14"/></>,
    trash:    <><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></>,
    check:    <><polyline points="20 6 9 17 4 12"/></>,
    shield:   <><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></>,
    save:     <><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></>,
    settings: <><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></>,
  };
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
      style={{ flexShrink: 0 }}>
      {icons[name]}
    </svg>
  );
};

function OtpDurationSection() {
  const [hours, setHours] = useState(24);
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get('/settings/otp-duration').then(({ data }) => {
      setHours(data.hours || 24);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);
  const handleSave = async () => {
    try {
      await api.post('/settings/otp-duration', { hours: parseInt(hours) });
      toast.success('Durée OTP mise à jour : ' + hours + 'h');
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch { toast.error('Erreur'); }
  };
  const presets = [
    { label: '1 h', value: 1 }, { label: '6 h', value: 6 },
    { label: '12 h', value: 12 }, { label: '24 h', value: 24 },
    { label: '48 h', value: 48 }, { label: '72 h', value: 72 },
    { label: '7 jours', value: 168 },
  ];
  if (loading) return <div style={{ color: '#555', fontSize: 12 }}>Chargement...</div>;
  return (
    <div>
      <p style={{ fontSize: 12, color: '#555', marginBottom: 12, lineHeight: 1.6 }}>
        {hours}h sélectionnées dans la référence ; les durées personnalisées sont distinctes.
      </p>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 16 }}>
        {presets.map(p => (
          <button key={p.value} onClick={() => setHours(p.value)}
            style={{ padding: '8px 14px', borderRadius: 10, border: 'none',
              background: hours === p.value ? '#d4f535' : '#1a1a1a',
              color: hours === p.value ? '#0a0a0a' : '#888',
              fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>
            {p.label}
          </button>
        ))}
      </div>
      <div style={{ marginBottom: 6, fontSize: 11, color: '#555' }}>Durée en heures</div>
      <input type="number" value={hours} onChange={e => setHours(parseInt(e.target.value))}
        min={1} max={8760}
        style={{ width: '100%', padding: '12px 14px', borderRadius: 10, border: '1px solid #222', background: '#0d0d0d', color: '#fff', fontSize: 14, outline: 'none', boxSizing: 'border-box', marginBottom: 6 }} />
      <div style={{ fontSize: 11, color: '#555', marginBottom: 14 }}>Appliqué à l'aperçu : {hours} h</div>
      <button onClick={handleSave}
        style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '12px 20px', borderRadius: 10, border: 'none', background: saved ? '#10b981' : '#d4f535', color: '#0a0a0a', fontWeight: 800, fontSize: 13, cursor: 'pointer' }}>
        <Icon name="save" size={15} color="#0a0a0a" />
        {saved ? 'Sauvegardé !' : 'Sauvegarder la durée'}
      </button>
    </div>
  );
}

function AdminEmailSection() {
  const [email, setEmail] = useState('');
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get('/settings/admin-email').then(({ data }) => {
      setEmail(data.email || '');
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);
  const handleSave = async () => {
    try {
      await api.post('/settings/admin-email', { email });
      toast.success('Email de notification sauvegardé');
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch { toast.error('Erreur'); }
  };
  if (loading) return <div style={{ color: '#555', fontSize: 12 }}>Chargement...</div>;
  return (
    <div>
      <p style={{ fontSize: 12, color: '#555', marginBottom: 6, lineHeight: 1.6 }}>Adresse de référence masquée · aucun envoi connecté.</p>
      <p style={{ fontSize: 11, color: '#444', marginBottom: 10 }}>Adresse configurée dans la capture · masquée</p>
      <div style={{ fontSize: 11, color: '#555', marginBottom: 6 }}>Adresse de test</div>
      <input type="email" value={email} onChange={e => setEmail(e.target.value)}
        placeholder="Adresse de test uniquement"
        style={{ width: '100%', padding: '12px 14px', borderRadius: 10, border: '1px solid #222', background: '#0d0d0d', color: '#fff', fontSize: 13, outline: 'none', boxSizing: 'border-box', marginBottom: 14 }} />
      <button onClick={handleSave}
        style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '12px 20px', borderRadius: 10, border: 'none', background: saved ? '#10b981' : '#d4f535', color: '#0a0a0a', fontWeight: 800, fontSize: 13, cursor: 'pointer' }}>
        <Icon name="save" size={15} color="#0a0a0a" />
        {saved ? 'Sauvegardé !' : 'Valider dans l\'aperçu'}
      </button>
    </div>
  );
}

function AIPromptSection() {
  const [prompt, setPrompt] = useState('');
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get('/settings/ai-prompt').then(({ data }) => {
      setPrompt(data.prompt || '');
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);
  const handleSave = async () => {
    try {
      await api.post('/settings/ai-prompt', { prompt });
      toast.success('Prompt IA sauvegardé');
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch { toast.error('Erreur sauvegarde'); }
  };
  const handleReset = async () => {
    setPrompt('');
    await api.post('/settings/ai-prompt', { prompt: '' });
    toast.success('Prompt réinitialisé');
  };
  if (loading) return <div style={{ color: '#555', fontSize: 12 }}>Chargement...</div>;
  return (
    <div>
      <p style={{ fontSize: 12, color: '#555', marginBottom: 6, lineHeight: 1.6 }}>Extrait visible uniquement ; le texte intermédiaire des captures n'est pas reconstitué.</p>
      <div style={{ fontSize: 11, color: '#555', marginBottom: 8 }}>Contexte d'analyse · extrait de référence</div>
      <textarea
        value={prompt}
        onChange={e => setPrompt(e.target.value)}
        rows={6}
        style={{ width: '100%', padding: '12px 14px', borderRadius: 10, border: '1px solid #222', background: '#0d0d0d', color: '#fff', fontSize: 12, outline: 'none', resize: 'vertical', fontFamily: 'inherit', lineHeight: 1.7, boxSizing: 'border-box', marginBottom: 6 }}
      />
      <div style={{ fontSize: 11, color: '#555', marginBottom: 14 }}>{prompt.length} / 5 000 caractères · vider pour choisir le défaut, non fourni.</div>
      <div style={{ display: 'flex', gap: 8 }}>
        <button onClick={handleSave}
          style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, padding: '12px', borderRadius: 10, border: 'none', background: saved ? '#10b981' : '#d4f535', color: '#0a0a0a', fontWeight: 800, fontSize: 13, cursor: 'pointer' }}>
          <Icon name="save" size={15} color="#0a0a0a" />
          {saved ? 'Sauvegardé !' : 'Sauvegarder le prompt'}
        </button>
        <button onClick={handleReset}
          style={{ padding: '12px 16px', borderRadius: 10, border: '1px solid #333', background: '#1a1a1a', fontWeight: 700, fontSize: 13, cursor: 'pointer', color: '#888', display: 'flex', alignItems: 'center', gap: 6 }}>
          <Icon name="refresh" size={14} color="#888" /> Défaut
        </button>
      </div>
    </div>
  );
}

export default function SettingsPage() {
  const [members, setMembers] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [adminPassword, setAdminPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [savingPwd, setSavingPwd] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState('');
  const [tab, setTab] = useState('acces');
  const [planStatus, setPlanStatus] = useState(null);
  const [planLoading, setPlanLoading] = useState(false);
  const [checkoutLoading, setCheckoutLoading] = useState('');
  const loadPlanStatus = async () => {
    setPlanLoading(true);
    try { const r = await api.get('/stripe/status'); setPlanStatus(r.data); }
    catch(e) { console.error('plan status:', e); }
    finally { setPlanLoading(false); }
  };

  const fetchData = useCallback(async () => {
    try {
      const [membersRes, statsRes] = await Promise.all([
        api.get('/members'),
        api.get('/settings'),
      ]);
      setMembers(membersRes.data);
      setStats(statsRes.data);
    } catch { toast.error('Erreur chargement'); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => { fetchData(); }, [fetchData]);

  const handleRevoke = async (id, name, current) => {
    try {
      await api.post('/members/' + id + '/revoke', { revoke: current });
      toast.success(current ? 'Accès révoqué' : 'Accès rétabli');
      fetchData();
    } catch { toast.error('Erreur'); }
  };
  const handleResetOTP = async (id, name) => {
    try {
      await api.post('/members/' + id + '/reset-otp');
      toast.success('OTP réinitialisé pour ' + name);
      fetchData();
    } catch { toast.error('Erreur'); }
  };
  const handleChangePassword = async () => {
    if (!adminPassword || !newPassword) { toast.error('Remplissez les deux champs'); return; }
    if (newPassword.length < 6) { toast.error('Min. 6 caractères'); return; }
    try {
      setSavingPwd(true);
      await api.put('/auth/change-password', { current_password: adminPassword, new_password: newPassword });
      toast.success('Mot de passe changé');
      setAdminPassword(''); setNewPassword('');
    } catch { toast.error('Mot de passe actuel incorrect'); }
    finally { setSavingPwd(false); }
  };
  const handleClearAllHistory = async () => {
    if (confirmDelete !== 'SUPPRIMER') { toast.error('Tapez SUPPRIMER pour confirmer'); return; }
    try {
      await api.delete('/settings/all-history');
      toast.success('Historique supprimé');
      setConfirmDelete('');
      fetchData();
    } catch { toast.error('Erreur'); }
  };
  const handleClearAllMembers = async () => {
    try {
      await api.delete('/settings/all-members');
      toast.success('Membres supprimés');
      fetchData();
    } catch { toast.error('Erreur'); }
  };
  const handleRegenAll = async () => {
    try {
      await api.post('/members/regenerate-all');
      toast.success('Liens régénérés');
      fetchData();
    } catch { toast.error('Erreur'); }
  };
  const handleClearAlerts = async () => {
    try {
      await api.delete('/settings/all-alerts');
      toast.success('Alertes supprimées');
    } catch { toast.error('Erreur'); }
  };

  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#0a0a0a' }}>
      <div style={{ color: '#d4f535', fontSize: 14 }}>Chargement...</div>
    </div>
  );

  const statItems = [
    { label: 'MEMBRES',         value: stats?.totalMembers || 0,       icon: 'users',    color: '#ffffff' },
    { label: 'ÉVÉNEMENTS',      value: stats?.totalEvents || 0,        icon: 'bell',     color: '#10b981' },
    { label: 'TÉLÉCHARGEMENTS', value: stats?.totalDownloads || 0,     icon: 'download', color: '#f59e0b' },
    { label: 'ACCÈS REFUSÉS',   value: stats?.totalUnauthorized || 0,  icon: 'slash',    color: '#ef4444' },
  ];

  const TABS = [
    { key: 'acces',  label: 'Accès' },
    { key: 'config', label: 'Configuration' },
    { key: 'data',   label: 'Données' },
    { key: 'plan',   label: 'Abonnement' },
  ];

  const sep = <div style={{ borderTop: '1px solid #1a1a1a', margin: '20px 0' }} />;
  const note = (
    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, padding: '10px 14px', background: '#0d0d0d', borderRadius: 10, border: '1px solid #1a1a1a', marginTop: 20 }}>
      <Icon name="shield" size={13} color="#555" />
      <span style={{ fontSize: 11, color: '#444', lineHeight: 1.6 }}>Mode aperçu · modifications non persistantes · aucun lien, code, e-mail ou mot de passe réel modifié.</span>
    </div>
  );

  return (
    <><Toaster position="top-right" /><div style={{ padding: 16, background: '#0a0a0a', minHeight: '100vh' }}>

      {/* Header */}
      <div style={{ marginBottom: 20 }}>
        <div style={{ fontSize: 10, color: '#555', fontWeight: 700, letterSpacing: 2, textTransform: 'uppercase', marginBottom: 6 }}>
          Administration / Configuration
        </div>
        <h1 style={{ fontSize: 28, fontWeight: 900, color: '#ffffff', letterSpacing: -1, marginBottom: 4 }}>Paramètres</h1>
        <p style={{ color: '#555', fontSize: 12 }}>Votre espace. Vos règles.</p>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 10 }}>
          <div style={{ width: 8, height: 8, borderRadius: '50%', background: '#d4f535', boxShadow: '0 0 8px #d4f53599' }} />
          <span style={{ fontSize: 11, color: '#888', fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase' }}>
            Référence · Captures du 13 Oct. 2026
          </span>
        </div>
        <button onClick={fetchData} style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 12, padding: '8px 14px', borderRadius: 10, border: '1.5px solid #333', background: '#111', color: '#fff', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>
          <Icon name="refresh" size={14} color="#fff" /> Restaurer l'aperçu
        </button>
      </div>

      {/* Stats 2x2 */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 20 }}>
        {statItems.map((s, i) => (
          <div key={i} style={{ background: '#111', border: '1px solid #1e1e1e', borderRadius: 14, padding: '14px 16px' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
              <span style={{ fontSize: 10, fontWeight: 700, color: '#555', letterSpacing: 1 }}>{s.label}</span>
              <Icon name={s.icon} size={16} color={s.color} />
            </div>
            <div style={{ fontSize: 32, fontWeight: 900, color: s.color, lineHeight: 1 }}>{s.value}</div>
            <div style={{ fontSize: 11, color: '#555', marginTop: 6 }}>Référence de ce module</div>
          </div>
        ))}
      </div>
      <div style={{ fontSize: 11, color: '#555', lineHeight: 1.7, marginBottom: 20 }}>
        Ces compteurs proviennent des paramètres de votre capture ; leur périmètre diffère des autres modules. Les simulations restent isolées ici.
      </div>

      {/* Onglets */}
      <div style={{ display: 'flex', borderBottom: '1px solid #1a1a1a', marginBottom: 20 }}>
        {TABS.map(t => (
          <button key={t.key} onClick={() => { setTab(t.key); if(t.key==='plan') loadPlanStatus(); }}
            style={{ padding: '10px 16px', background: 'none', border: 'none', borderBottom: tab === t.key ? '2px solid #d4f535' : '2px solid transparent', color: tab === t.key ? '#d4f535' : '#555', fontSize: 14, fontWeight: tab === t.key ? 800 : 500, cursor: 'pointer', marginBottom: -1 }}>
            {t.label}
          </button>
        ))}
      </div>

      {/* ─── ONGLET ACCÈS ─── */}
      {tab === 'acces' && (
        <div>
          <div style={{ marginBottom: 16 }}>
            <h3 style={{ fontSize: 16, fontWeight: 800, color: '#ffffff', marginBottom: 4 }}>Accès membres</h3>
            <p style={{ fontSize: 12, color: '#555' }}>Deux membres visibles · contacts masqués.</p>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
            {members.map((m, i) => (
              <div key={m.id}>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12, padding: '16px 0' }}>
                  {/* Avatar */}
                  <div style={{ width: 40, height: 40, borderRadius: 10, background: '#1a1a1a', border: '1px solid #333', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <span style={{ fontSize: 16, fontWeight: 900, color: '#d4f535' }}>
                      {(m.name || '?')[0].toUpperCase()}
                    </span>
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 800, fontSize: 14, color: '#ffffff', marginBottom: 2 }}>{m.name}</div>
                    <div style={{ fontSize: 12, color: '#555', marginBottom: 8 }}>Contact masqué</div>
                    <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap', marginBottom: 12 }}>
                      <span style={{ fontSize: 11, fontWeight: 700, color: '#10b981' }}>
                        {m.is_revoked === true ? 'Révoqué' : 'Actif'} · aperçu
                      </span>
                      <span style={{ fontSize: 11, color: '#555' }}>v{m.version}</span>
                      <span style={{ fontSize: 11, color: '#555' }}>{m.total_opens} ouverture{m.total_opens !== 1 ? 's' : ''}</span>
                    </div>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <button onClick={() => handleRevoke(m.id, m.name, !m.is_revoked)}
                        style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '8px 14px', borderRadius: 10, border: '1px solid #333', background: '#1a1a1a', color: '#ffffff', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>
                        <Icon name="slash" size={13} color="#fff" />
                        {m.is_revoked === true ? 'Rétablir' : 'Révoquer'}
                      </button>
                      <button onClick={() => handleResetOTP(m.id, m.name)}
                        style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '8px 14px', borderRadius: 10, border: '1px solid #333', background: '#1a1a1a', color: '#ffffff', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>
                        <Icon name="refresh" size={13} color="#fff" /> Reset OTP
                      </button>
                    </div>
                  </div>
                </div>
                {i < members.length - 1 && <div style={{ borderTop: '1px solid #1a1a1a' }} />}
              </div>
            ))}
          </div>

          <button onClick={handleRegenAll}
            style={{ width: '100%', marginTop: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, padding: '13px', borderRadius: 12, border: '1px solid #333', background: '#111', color: '#ffffff', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>
            <Icon name="refresh" size={15} color="#fff" /> Régénérer tous les liens
          </button>

          {sep}

          {/* PDF Global */}
          <h3 style={{ fontSize: 16, fontWeight: 800, color: '#ffffff', marginBottom: 6 }}>Téléchargement PDF — Global</h3>
          <p style={{ fontSize: 12, color: '#555', marginBottom: 6 }}>Autorisation commune aux membres de cet aperçu.</p>
          <p style={{ fontSize: 13, color: '#555', marginBottom: 16 }}>État : <span style={{ color: members.every(m => m.download_allowed) ? '#10b981' : members.every(m => !m.download_allowed) ? '#ef4444' : '#f59e0b', fontWeight: 700 }}>{members.every(m => m.download_allowed) ? 'Tous autorisés' : members.every(m => !m.download_allowed) ? 'Tous bloqués' : 'Mixte'}</span></p>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
            <button onClick={async () => {
              try { await api.post('/members/global/set-download', { allow: true }); toast.success('Téléchargement autorisé pour tous'); fetchData(); }
              catch { toast.error('Erreur'); }
            }} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, padding: '12px', borderRadius: 10, border: '1px solid #333', background: '#1a1a1a', color: '#fff', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>
              <Icon name="check" size={14} color="#10b981" /> Autoriser tous
            </button>
            <button onClick={async () => {
              try { await api.post('/members/global/set-download', { allow: false }); toast.success('Téléchargement bloqué pour tous'); fetchData(); }
              catch { toast.error('Erreur'); }
            }} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, padding: '12px', borderRadius: 10, border: '1px solid #333', background: '#1a1a1a', color: '#fff', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>
              <Icon name="slash" size={14} color="#ef4444" /> Bloquer tous
            </button>
          </div>

          {sep}

          {/* PIN global */}
          <h3 style={{ fontSize: 16, fontWeight: 800, color: '#ffffff', marginBottom: 6 }}>PIN — Envoi global</h3>
          <p style={{ fontSize: 12, color: '#555', marginBottom: 10 }}>Envoi réel par email à tous les membres actifs.</p>
          <p style={{ fontSize: 12, color: '#444', marginBottom: 16, lineHeight: 1.6 }}>Génère un PIN pour les membres qui n'en ont pas encore, puis envoie les codes par email.</p>
          <button onClick={async () => {
            try {
              toast.loading('Génération en cours...', { id: 'genpins' });
              const { data } = await api.post('/members/generate-missing-pins');
              toast.success(data.generated + ' PINs générés', { id: 'genpins', duration: 5000 });
            } catch { toast.error('Erreur', { id: 'genpins' }); }
          }} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '13px 20px', borderRadius: 12, background: 'linear-gradient(135deg,#6366f1,#8b5cf6)', border: 'none', color: '#fff', fontWeight: 700, fontSize: 13, cursor: 'pointer', marginBottom: 10 }}>
            <Icon name="zap" size={15} color="#fff" /> Générer les PINs manquants
          </button>
          <button onClick={async () => {
            try {
              toast.loading('Envoi en cours...', { id: 'pins' });
              const { data } = await api.post('/members/global/send-pins');
              toast.success(data.sent + ' PINs envoyés sur ' + data.total + ' membres', { id: 'pins', duration: 6000 });
            } catch { toast.error('Erreur', { id: 'pins' }); }
          }} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '13px 20px', borderRadius: 10, border: 'none', background: '#d4f535', color: '#0a0a0a', fontSize: 13, fontWeight: 800, cursor: 'pointer' }}>
            <Icon name="key" size={15} color="#0a0a0a" /> Envoyer les PINs par email
          </button>

          {note}
        </div>
      )}

      {/* ─── ONGLET CONFIGURATION ─── */}
      {tab === 'config' && (
        <div>
          <h3 style={{ fontSize: 16, fontWeight: 800, color: '#ffffff', marginBottom: 6 }}>Durée de validité OTP</h3>
          <OtpDurationSection />
          {sep}
          <h3 style={{ fontSize: 16, fontWeight: 800, color: '#ffffff', marginBottom: 6 }}>E-mail de notifications</h3>
          <AdminEmailSection />
          {sep}
          <h3 style={{ fontSize: 16, fontWeight: 800, color: '#ffffff', marginBottom: 6 }}>Mot de passe admin</h3>
          <p style={{ fontSize: 12, color: '#555', marginBottom: 14 }}>Changement de compte non disponible dans cet aperçu.</p>
          <div style={{ marginBottom: 10 }}>
            <label style={{ display: 'block', fontSize: 11, color: '#555', marginBottom: 6 }}>Mot de passe actuel</label>
            <input type="password" value={adminPassword} onChange={e => setAdminPassword(e.target.value)}
              placeholder="Non collecté dans l'aperçu"
              style={{ width: '100%', padding: '12px 14px', borderRadius: 10, border: '1px solid #222', background: '#0d0d0d', color: '#fff', fontSize: 13, outline: 'none', boxSizing: 'border-box' }} />
          </div>
          <div style={{ marginBottom: 14 }}>
            <label style={{ display: 'block', fontSize: 11, color: '#555', marginBottom: 6 }}>Nouveau mot de passe</label>
            <input type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)}
              placeholder="Non collecté dans l'aperçu"
              style={{ width: '100%', padding: '12px 14px', borderRadius: 10, border: '1px solid #222', background: '#0d0d0d', color: '#fff', fontSize: 13, outline: 'none', boxSizing: 'border-box' }} />
          </div>
          <button onClick={handleChangePassword} disabled={savingPwd}
            style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '12px 20px', borderRadius: 10, border: 'none', background: '#1a1a1a', color: '#888', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>
            <Icon name="lock" size={15} color="#888" />
            {savingPwd ? 'Enregistrement...' : 'Changer le mot de passe'}
          </button>
          {sep}
          <h3 style={{ fontSize: 16, fontWeight: 800, color: '#ffffff', marginBottom: 6 }}>Prompt IA personnalisé</h3>
          <AIPromptSection />
          {note}
        </div>
      )}

      {/* ─── ONGLET DONNÉES ─── */}
      {tab === 'data' && (
        <div>
          <h3 style={{ fontSize: 16, fontWeight: 800, color: '#ffffff', marginBottom: 6 }}>Suppression de données</h3>
          <p style={{ fontSize: 12, color: '#555', marginBottom: 20, lineHeight: 1.6 }}>Actions simulées et isolées dans les paramètres ; aucun autre module n'est effacé.</p>

          <button onClick={handleClearAlerts}
            style={{ width: '100%', display: 'flex', alignItems: 'center', gap: 8, padding: '13px 16px', borderRadius: 12, border: '1px solid #333', background: '#111', color: '#fff', fontSize: 13, fontWeight: 700, cursor: 'pointer', marginBottom: 16 }}>
            <Icon name="bell" size={15} color="#fff" /> Supprimer toutes les alertes
          </button>

          <div style={{ borderTop: '1px solid #1a1a1a', paddingTop: 16, marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#ef4444', marginBottom: 10 }}>
              Supprimer tout l'historique des événements
            </label>
            <input value={confirmDelete} onChange={e => setConfirmDelete(e.target.value)}
              placeholder="Tapez SUPPRIMER pour confirmer"
              style={{ width: '100%', padding: '12px 14px', borderRadius: 10, border: '1px solid #333', background: '#0d0d0d', color: '#fff', fontSize: 13, outline: 'none', boxSizing: 'border-box', marginBottom: 10 }} />
            <button onClick={handleClearAllHistory}
              style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '12px 20px', borderRadius: 10, border: 'none', background: '#7f1d1d', color: '#fca5a5', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>
              <Icon name="trash" size={14} color="#fca5a5" /> Supprimer tout l'historique
            </button>
          </div>

          <div style={{ borderTop: '1px solid #1a1a1a', paddingTop: 16 }}>
            <button onClick={handleClearAllMembers}
              style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '12px 20px', borderRadius: 10, border: '1px solid #333', background: '#111', color: '#ef4444', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>
              <Icon name="users" size={14} color="#ef4444" /> Supprimer tous les membres
            </button>
          </div>

          {note}
        </div>
      )}

      {/* ─── ONGLET ABONNEMENT ─── */}
      {tab === 'plan' && (
        <div>
          <h3 style={{ fontSize: 16, fontWeight: 800, color: '#ffffff', marginBottom: 6 }}>Votre abonnement</h3>
          <p style={{ fontSize: 12, color: '#555', marginBottom: 20 }}>Gérez votre plan et vos limites.</p>
          {planLoading ? (
            <div style={{ color: '#555', fontSize: 13 }}>Chargement...</div>
          ) : planStatus ? (
            <div>
              <div style={{ background: '#111', border: '1px solid #1e1e1e', borderRadius: 14, padding: '16px', marginBottom: 16 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                  <div>
                    <div style={{ fontSize: 10, color: '#555', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 4 }}>PLAN ACTUEL</div>
                    <div style={{ fontSize: 22, fontWeight: 900, color: planStatus.plan === 'free' ? '#888' : planStatus.plan === 'starter' ? '#d4f535' : planStatus.plan === 'pro' ? '#a78bfa' : '#34d399', textTransform: 'uppercase' }}>
                      {planStatus.plan === 'free' ? 'Gratuit' : planStatus.plan === 'starter' ? 'Starter' : planStatus.plan === 'pro' ? 'Pro' : 'Business'}
                    </div>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: 10, color: '#555', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 4 }}>STATUT</div>
                    <div style={{ fontSize: 13, fontWeight: 700, color: planStatus.stripe_status === 'active' ? '#10b981' : planStatus.stripe_status === 'past_due' ? '#f59e0b' : '#555' }}>
                      {planStatus.stripe_status === 'active' ? '● Actif' : planStatus.stripe_status === 'past_due' ? '⚠ Impayé' : '○ Inactif'}
                    </div>
                  </div>
                </div>
                <div style={{ marginBottom: 10 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, color: '#555', marginBottom: 4 }}>
                    <span>Documents</span>
                    <span style={{ color: planStatus.doc_count >= planStatus.doc_limit ? '#ef4444' : '#888' }}>{planStatus.doc_count} / {planStatus.doc_limit}</span>
                  </div>
                  <div style={{ height: 6, background: '#1a1a1a', borderRadius: 3, overflow: 'hidden' }}>
                    <div style={{ height: '100%', borderRadius: 3, width: Math.min(100, (planStatus.doc_count / planStatus.doc_limit) * 100) + '%', background: planStatus.doc_count >= planStatus.doc_limit ? '#ef4444' : '#d4f535', transition: 'width 0.3s' }} />
                  </div>
                </div>
                <div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, color: '#555', marginBottom: 4 }}>
                    <span>Membres</span>
                    <span style={{ color: planStatus.member_count >= planStatus.member_limit ? '#ef4444' : '#888' }}>{planStatus.member_count} / {planStatus.member_limit}</span>
                  </div>
                  <div style={{ height: 6, background: '#1a1a1a', borderRadius: 3, overflow: 'hidden' }}>
                    <div style={{ height: '100%', borderRadius: 3, width: Math.min(100, (planStatus.member_count / planStatus.member_limit) * 100) + '%', background: planStatus.member_count >= planStatus.member_limit ? '#ef4444' : '#a78bfa', transition: 'width 0.3s' }} />
                  </div>
                </div>
              </div>
              {planStatus.plan === 'free' && (
                <div>
                  <div style={{ fontSize: 11, color: '#555', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 12 }}>PASSER À UN PLAN SUPÉRIEUR</div>
                  {[
                    { id: 'starter', name: 'Starter', price: '9,99€', color: '#d4f535', textColor: '#0a0a0a', docs: 20, members: 50 },
                    { id: 'pro', name: 'Pro', price: '19,99€', color: '#a78bfa', textColor: '#fff', docs: 100, members: 200 },
                    { id: 'enterprise', name: 'Business', price: '29,99€', color: '#34d399', textColor: '#0a0a0a', docs: '∞', members: '∞' },
                  ].map(plan => (
                    <div key={plan.id} style={{ background: '#111', border: '1px solid #1e1e1e', borderRadius: 12, padding: '14px 16px', marginBottom: 10, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
                      <div>
                        <div style={{ fontSize: 14, fontWeight: 800, color: plan.color, marginBottom: 2 }}>{plan.name}</div>
                        <div style={{ fontSize: 11, color: '#555' }}>{plan.docs} docs · {plan.members} membres</div>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div style={{ fontSize: 15, fontWeight: 900, color: '#fff' }}>{plan.price}<span style={{ fontSize: 10, color: '#555', fontWeight: 400 }}>/mois</span></div>
                        <button
                          disabled={!!checkoutLoading}
                          onClick={async () => {
                            setCheckoutLoading(plan.id);
                            try {
                              const r = await api.post('/stripe/create-checkout', { plan: plan.id });
                              if (r.data.url) window.location.href = r.data.url;
                              else toast.error(r.data.error || 'Erreur Stripe');
                            } catch(e) { toast.error(e.response?.data?.error || 'Erreur Stripe'); }
                            finally { setCheckoutLoading(''); }
                          }}
                          style={{ padding: '9px 16px', borderRadius: 8, border: 'none', background: plan.color, color: plan.textColor, fontSize: 12, fontWeight: 800, cursor: checkoutLoading ? 'not-allowed' : 'pointer', opacity: checkoutLoading && checkoutLoading !== plan.id ? 0.5 : 1, whiteSpace: 'nowrap' }}>
                          {checkoutLoading === plan.id ? '...' : 'Choisir'}
                        </button>
                      </div>
                    </div>
                  ))}
                  <div style={{ fontSize: 11, color: '#444', marginTop: 8, textAlign: 'center' }}>Paiement sécurisé par Stripe · résiliation à tout moment</div>
                </div>
              )}
              {planStatus.plan !== 'free' && (
                <div style={{ marginTop: 8 }}>
                  <button onClick={async () => {
                    if (!window.confirm('Annuler votre abonnement à la fin de la période ?')) return;
                    try { await api.post('/stripe/cancel'); toast.success('Abonnement annulé à la fin de la période'); loadPlanStatus(); }
                    catch(e) { toast.error(e.response?.data?.error || 'Erreur'); }
                  }} style={{ padding: '10px 18px', borderRadius: 10, border: '1px solid #333', background: '#111', color: '#ef4444', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>
                    Annuler l'abonnement
                  </button>
                </div>
              )}
            </div>
          ) : (
            <button onClick={loadPlanStatus} style={{ padding: '11px 20px', borderRadius: 10, border: '1px solid #333', background: '#111', color: '#fff', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>
              Charger le statut
            </button>
          )}
        </div>
      )}
    </div>
  </>
  );
}
